import styled, { css } from 'styled-components'
import { media } from '../../layouts/utils';

export const ContainerList = styled.div`
    display: flex;
    ${({ maxOffer }) => maxOffer ?
        css`
            justify-content: space-between;
        ` : 
        css`
            justify-content: center;
            & > div {
                margin-right: 24px;
            }

            & > div:last-child {
                margin-right: 0;
            }

            ${media.phone`
                & > div:nth-child(n+1) {
                    margin: 0;
                    width: 100%;

                    &:only-child > div > div:last-child {
                        flex-direction: row;
                    }                   
                }
            `}
        `};
    
    width: 90%;
    margin-top: 10px;
    padding-bottom: 80px;
    padding-right: 10px;

    ${media.phone`
        width: 100%;
        padding: 0 0 48px 24px;
        max-width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    `}
`
